import React from 'react';

import { purple } from 'utils/color-styles';
import { formatFullName } from 'utils/formatFullName';

export interface UserChipProps {
  user?: {
    fullName?: {
      first?: string | null;
      last?: string | null;
    } | null;
    mainPicture?: string | null;
  };
  small?: boolean;
  disabled?: boolean;
}
const UserChip = ({ user, small, disabled }: UserChipProps): JSX.Element | null => {
  const logo = user?.mainPicture;
  const name = formatFullName(user?.fullName);

  if (!user) {
    return null;
  }

  return (
    <div
      style={{
        display: 'inline-flex',
        flexDirection: 'row',
        alignItems: 'center',
        height: 32,
        overflow: 'hidden',
        padding: logo ? 0 : '6px 2px',
        opacity: disabled ? 0.38 : 1,
      }}
    >
      {logo ? (
        <img
          alt={name}
          src={logo}
          style={{
            width: small ? 24 : 32,
            height: small ? 24 : 32,
            borderRadius: 16,
            margin: 1,
            overflow: 'hidden',
            border: '1px solid',
            borderColor: purple,
          }}
        />
      ) : null}
      <div
        style={{
          fontSize: 12,
          marginLeft: logo ? 6 : 12,
          marginRight: 12,
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
        }}
      >
        {name}
      </div>
    </div>
  );
};

export default UserChip;
